module.exports = __webpack_public_path__ + "static/media/sm_twitter.098b104c.svg";